import { render, staticRenderFns } from "./FeatureMapping.vue?vue&type=template&id=75fa36e6&scoped=true&"
import script from "./FeatureMapping.vue?vue&type=script&lang=ts&"
export * from "./FeatureMapping.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureMapping.vue?vue&type=style&index=0&id=75fa36e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fa36e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
